export const initialAbility = [
  {
    action: 'view',
    subject: 'public',
  },
]

export const _ = undefined
